module.exports = __webpack_public_path__ + "img/Getafe.3b4be7e5.png";